import reduce from "lodash/reduce";

export default function removeSpaceComma(
    obj: Record<string, any>
): Record<string, any> {
    return reduce(obj, (result, value, key) => Object.assign(result, { [key]: value.replace(/,\s+/g, ',') }), {});
}
